import DataItemModelBase from '../_generated/modelBases/data-item-model-base';

export default class DataItemModel extends DataItemModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
